import { render, staticRenderFns } from "./ForeignUs.vue?vue&type=template&id=57d3794e&scoped=true"
import script from "./ForeignUs.vue?vue&type=script&lang=js"
export * from "./ForeignUs.vue?vue&type=script&lang=js"
import style0 from "./ForeignUs.vue?vue&type=style&index=0&id=57d3794e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3794e",
  null
  
)

export default component.exports